<template>
  <div :class="['input-container', {focused: isLabelCollapsed}]">
    <input
      v-on="$listeners"
      v-model="__modelValue"
      ref="baseTextInput"
      :id="inputId"
      :class="[inputClass, {has_error: invalid}]"
      :name="inputName"
      @focus="handleInputFocus"
      @blur="handleInputBlur"
    />

    <label :for="inputId" class="placeholder-label">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'BaseTextFormInput',
  emits: ['update:modelValue'],
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    inputName: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      default: 'inputText'
    },
    invalid: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isInputFocused: false,
      isAutoFilled: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.baseTextInput && this.$refs.baseTextInput.addEventListener) {
        this.$refs.baseTextInput.addEventListener('animationstart', this.handleAnimation)
      }
    })
  },
  computed: {
    __modelValue: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    },
    isLabelCollapsed () {
      return !!this.__modelValue || this.isInputFocused || this.isAutoFilled
    }
  },
  methods: {
    handleInputFocus () {
      this.isInputFocused = true
    },
    handleInputBlur () {
      this.isInputFocused = false
    },
    handleAnimation (e) {
      this.isAutoFilled = e.animationName === 'onAutoFillStart'
    }
  },
  beforeDestroy () {
    if (this.$refs.baseTextInput && this.$refs.baseTextInput.removeEventListener) {
      this.$refs.baseTextInput.removeEventListener('animationstart', this.handleAnimation)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/formInput/BaseTextFormInput.vue